export default "__VITE_ASSET__Cc$RG4BS__"